window.addEventListener('load', function () {
  // --- For landing page testimonial custom section ---
  const landingSliderTesti = document.querySelector('.testimonial-col-inner');
  
  // Check if the element exists and Splide is loaded before initializing
  if (landingSliderTesti && typeof Splide !== 'undefined') {
    const ladingSlidetestimonial = new Splide(landingSliderTesti, {
      type: 'loop',
      perPage: 3,
      perMove: 1,
      gap: 24,
      pagination: false,
      arrows: false,
      autoplay: true,
      breakpoints: {
        1024: {
          perPage: 2,
          perMove: 1,
          rewind: true,
          autoplay: true,
          gap: 20,
        },
        767: {
          perPage: 1,
          perMove: 1,
          rewind: true,
          focus: 'center',
          autoplay: true,
          gap: 20,
        },
      }
    });
    
    ladingSlidetestimonial.mount();
  }
});